module.exports = __webpack_public_path__ + "static/img/product7.3e3e5504.png";